import styled from 'styled-components';

import { EditIcon, TrashIcon } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 16px;
  background: ${ct({ Dark: Colors.White, Light: Colors.White })};
  border-bottom: 1px solid ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
`;

export const VerticalSeparator = styled.div`
  height: 100%;
  width: 1px;
  background: ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
`;

export const StyledEditIcon = styled(EditIcon)`
  margin-right: 5px;
`;

export const StyledTrashIcon = styled(TrashIcon)`
  margin-right: 5px;
`;
